import "./App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import SwipeBackHome from "./components/SwipeBackHome";
import Home from "./pages/Home";
import Compare from "./pages/Compare";
import Providers from "./pages/Providers";
import ProviderDetail from "./pages/ProviderDetail";
import Locations from "./pages/Locations";
import Resources from "./pages/Resources";
import About from "./pages/About";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { ContentProvider } from "./context/ContentContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";

function PublicLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <SwipeBackHome />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/providers" element={<Providers />} />
                <Route path="/providers/:slug" element={<ProviderDetail />} />
                <Route path="/locations" element={<Locations />} />
                <Route path="/locations/:city" element={<Locations />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/about" element={<About />} />
              </Route>
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </ContentProvider>
      </AdminAuthProvider>
    </div>
  );
}

export default App;
